/* Continuous scroll for collection pages: nearing the foot of the product
   grid fetches the next page and appends it, so nobody ever meets a "Page 2".

   THE THING THAT BIT US: Dawn's facet filters re-render #product-grid over
   AJAX and push a new URL, without reloading the page. An earlier version
   read the "next page" link once at load and kept it, so after sorting or
   filtering it went on appending pages of the UNFILTERED collection: products
   that matched the filter became unreachable and others appeared twice.

   So nothing is cached. The next page is derived from the CURRENT URL each
   time, and whenever the query string changes (a filter or sort), the counter
   resets, because Dawn has just replaced the grid with a fresh page one. */
(function () {
  if (!document.getElementById('product-grid')) return;

  function baseParams() {
    var p = new URLSearchParams(window.location.search);
    p.delete('page');
    return p;
  }

  function pageOf(search) {
    var m = /[?&]page=(\d+)/.exec(search);
    return m ? parseInt(m[1], 10) : 1;
  }

  // Only run where there is genuinely more than one page to walk.
  function paginationExists() {
    return !!document.querySelector('.pagination-wrapper a[href*="page="]');
  }
  if (!paginationExists()) return;

  document.documentElement.classList.add('krumb-infinite-on');

  var filterKey = baseParams().toString();
  var loadedPage = pageOf(window.location.search);
  var exhausted = false;
  var busy = false;
  var MAX_PAGES = 40; // runaway guard, far beyond any real collection
  // A short page is the last page. Shopify answers an out-of-range ?page= with
  // repeated content rather than an empty grid, so without this the script
  // went on probing pages long past the end of the collection.
  var pageSize = (function () {
    var grid = document.getElementById('product-grid');
    return grid ? grid.children.length : 0;
  })();

  // Shopify serves an out-of-range ?page= by repeating content rather than
  // returning nothing, so "did this page add anything NEW" is the only
  // trustworthy stop signal. Identity is the product link.
  var seen = Object.create(null);
  function keyOf(li) {
    var a = li.querySelector('a[href*="/products/"]');
    return a ? a.getAttribute('href').split('?')[0] : null;
  }
  function rememberExisting() {
    seen = Object.create(null);
    var grid = document.getElementById('product-grid');
    if (!grid) return;
    Array.prototype.slice.call(grid.children).forEach(function (li) {
      var k = keyOf(li);
      if (k) seen[k] = true;
    });
  }
  rememberExisting();

  function syncToUrl() {
    var key = baseParams().toString();
    if (key === filterKey) return;
    // Dawn re-rendered the grid for a new filter or sort: start again.
    filterKey = key;
    loadedPage = pageOf(window.location.search);
    exhausted = false;
    busy = false;
    rememberExisting();
  }

  function nextUrl() {
    var p = baseParams();
    p.set('page', String(loadedPage + 1));
    return window.location.pathname + '?' + p.toString();
  }

  function nearBottom() {
    var grid = document.getElementById('product-grid');
    if (!grid) return false;
    return grid.getBoundingClientRect().bottom < window.innerHeight + 800;
  }

  function loadMore() {
    if (busy || exhausted) return;
    busy = true;
    var requestedFor = filterKey;
    var url = nextUrl();
    fetch(url)
      .then(function (r) { return r.ok ? r.text() : null; })
      .then(function (html) {
        // `busy` is held until loadedPage has advanced. Releasing it earlier
        // left a window in which a scroll event refetched the SAME page, and
        // every product was appended twice.
        if (html === null || requestedFor !== baseParams().toString()) {
          busy = false;
          syncToUrl();
          return;
        }
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var incoming = doc.getElementById('product-grid');
        var grid = document.getElementById('product-grid');
        var added = 0;
        if (grid && incoming) {
          Array.prototype.slice.call(incoming.children).forEach(function (li) {
            var k = keyOf(li);
            if (k && seen[k]) return; // already on the page
            if (k) seen[k] = true;
            grid.appendChild(document.importNode(li, true));
            added++;
          });
        }
        // Nothing new means we have reached the end, whatever the server sent.
        if (!added) { exhausted = true; busy = false; return; }
        if (pageSize && incoming.children.length < pageSize) exhausted = true;
        loadedPage += 1;
        if (loadedPage >= MAX_PAGES) exhausted = true;
        busy = false;
        if (nearBottom()) loadMore();
      })
      .catch(function () { busy = false; });
  }

  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      ticking = false;
      syncToUrl();
      if (nearBottom()) loadMore();
    });
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
  window.addEventListener('popstate', syncToUrl);
  onScroll();
})();
